export const WorkPackageRouting = [
  {
    path: "/maintenanceSetting/workPackage",
    name: "maintenanceSetting-workPackage-list",
    meta: { title: "工作包配置" },
    component: () =>
      import(
        /* webpackCh`un`kName: "maintenanceSetting-workPackage" */ "@/views/maintenance/workPackage/list/index.vue"
      ),
  },
];
